<template>
  <v-card>
    <div class="d-flex justify-end align-end mx-6">
      <CreateGroupHeadDialog v-if="canCreateGroupHead" />
    </div>
    <GroupHeadDetail />
  </v-card>
</template>
<script>
import GroupHeadDetail from './group-head/GroupHeadDetail.vue'
import CreateGroupHeadDialog from './group-head/CreateGroupHeadDialog.vue'
export default {
  components: { GroupHeadDetail, CreateGroupHeadDialog },
  computed: {
    canCreateGroupHead() {
      return true
    }
  }
}
</script>
